import { apiFetch } from './auth';

// Recupera la lista combinata di PM (ruolo PMRichiedente) e Senior (ruolo Richiedente)
// dal backend, che li legge tramite Microsoft Graph API.
// Richiede permesso Graph Application.Read.All sul Service Principal Azure.
// Se il permesso manca, il backend risponde con liste vuote senza errore.
export async function getManagerList() {
  const response = await apiFetch('/api/azure/directory/planning/members', {
    credentials: 'include',
  });

  let responseJson;
  try {
    responseJson = await response.json();
  } catch (error) {
    throw new Error('La risposta del server non è un JSON valido');
  }

  if (responseJson.status !== 'OK') {
    const message =
      responseJson?.message ||
      `Richiesta fallita con status ${response.status}`;
    throw new Error(message);
  }
  const { pm = [], senior = [] } = responseJson.info;
  return {pm, senior};
}

// Recupera i Senior (ruolo Richiedente) con nome ed email dal backend.
// Serve l'email (a differenza di getManagerList, che ritorna solo il nome)
// perché va salvata come identità univoca nell'associazione Senior -> PM.
export async function getSeniorCandidates() {
  const response = await apiFetch('/api/azure/directory/role/members/detailed?name=Richiedente', {
    credentials: 'include',
  });

  let responseJson;
  try {
    responseJson = await response.json();
  } catch (error) {
    throw new Error('La risposta del server non è un JSON valido');
  }

  if (responseJson.status !== 'OK') {
    const message = responseJson?.message || `Richiesta fallita con status ${response.status}`;
    throw new Error(message);
  }
  return responseJson.info?.members ?? [];
}